module.exports = __webpack_public_path__ + "static/media/avatar.681d1112.png";